import { Component, computed, inject, model } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { VisitorAdminService } from '@api-client';
import { ChartComponent, ChartOptions, DateRange } from '@client-libs';
import { StatisticsStore } from '../../../../stores/statistics.store';

@Component({
  selector: 'app-popular-page',
  templateUrl: './popular-page.component.html',
  imports: [ChartComponent, DateRange],
})
export class PopularPageComponent {
  readonly visitorService = inject(VisitorAdminService);
  readonly statisticsStore = inject(StatisticsStore);

  $data = rxResource({
    stream: ({ params }) =>
      this.visitorService.visitorAdminControllerGetPopularPageV1({
        endAt: this.endAt()?.toString()!,
        startAt: this.startAt()?.toString()!,
        type: 'month',
      }),
  });
  data = computed(() => this.$data.value());

  startAt = model<Date>();
  endAt = model<Date>();

  options = computed<ChartOptions>(() => ({
    tooltip: {
      custom: (data: any) => this.customTooltip(data),
    },
    plotOptions: {
      bar: {
        columnWidth: '20%',
      },
    },
    chart: {
      type: 'bar',
      fontFamily: 'inherit',
      height: 240,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ['#2b7fff'],
    series: [
      {
        name: '총 방문자 수',
        data: this.data()?.counts ?? [],
      },
    ],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    labels: this.data()?.pageUrls,
  }));

  customTooltip(data: any) {
    const { series, seriesIndex, dataPointIndex } = data;

    return `<div class="min-w-[3rem] tooltip-shadow p-2.5 flex flex-col justify-center items-center gap-1">
              <div class="text-base-content">총 방문자 수 : ${series[seriesIndex][dataPointIndex]}명</div>
              <div class="text-base-content/60">${this.options().labels[dataPointIndex]}</div>
            </div>`;
  }

  handleDateChange() {
    if (this.startAt() && this.endAt()) {
      this.$data.reload();
      this.statisticsStore.setDateOption(this.startAt()!, this.endAt()!);
    }
  }

  handleReset() {
    this.startAt.set(undefined);
    this.endAt.set(undefined);
    this.statisticsStore.reset();
    this.$data.reload();
  }
}
